import { briefStream } from '@/mocks/home';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function BriefStream() {
  return (
    <section id="topic" aria-label="短讯速览">
      <SectionHeading
        kicker="SHORT NEWS"
        title="短讯速览"
        desc="标题优先、摘要克制，一条一条往下看，密度拉满也不费力。"
        actionLabel="查看全部短讯"
        actionHref="#archive"
      />

      <ul className="grid grid-cols-1 gap-px overflow-hidden rounded-lg border border-background-200 bg-background-200 sm:grid-cols-2">
        {briefStream.map((item) => (
          <li key={item.id} className="group bg-background-50 p-4 transition-colors hover:bg-background-100 md:p-5">
            <a href="#topic" className="block cursor-pointer">
              <div className="flex items-center gap-2">
                <span className="rounded border border-secondary-200 bg-secondary-100 px-1.5 py-0.5 text-[11px] font-medium text-secondary-900">
                  {item.tag}
                </span>
                <span className="flex items-center gap-1 text-[11px] text-foreground-500">
                  <i className="ri-time-line" aria-hidden="true"></i>
                  {item.time}
                </span>
              </div>
              <h3 className="mt-2 text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-[15px]">
                {item.title}
              </h3>
              <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                {item.summary}
              </p>
              <div className="mt-3 flex items-center justify-between">
                <span className="flex items-center gap-1 text-[11px] text-accent-700">
                  <i className="ri-fire-line" aria-hidden="true"></i>
                  {item.heat}
                </span>
                <span className="flex items-center gap-1 text-[11px] text-foreground-500 transition-colors group-hover:text-primary-600">
                  阅读全文
                  <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
                </span>
              </div>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}